import { fireEvent, render, screen } from '@testing-library/react'
import ActivismPage from './ActivismPage'

describe('ActivismPage', () => {
  test('renders the activism content as a standalone page', () => {
    render(<ActivismPage />)

    expect(screen.getByRole('heading', { name: /activismo menstrual/i, level: 1 })).toBeTruthy()
    expect(screen.getByRole('link', { name: /volver/i }).getAttribute('href')).toBe('/asociacion')
    expect(screen.getByText(/transformaci/i)).toBeTruthy()
    expect(screen.getAllByText(/activismo menstrual/i).length).toBeGreaterThan(0)
    expect(screen.getByText(/situando la ciclicidad, la salud sexual y \(no\)reproductiva y los derechos menstruales y climatéricos/i)).toBeTruthy()
    const footnoteToggle = screen.getByRole('button', { name: '*' })
    expect(footnoteToggle.getAttribute('aria-expanded')).toBe('false')
    fireEvent.click(footnoteToggle)
    expect(screen.getByText(/la condición de menstruar no determina la identidad de género/i)).toBeTruthy()
    expect(screen.getByRole('heading', { name: /nuestros ámbitos de acción/i, level: 2 })).toBeTruthy()
    expect(screen.getAllByText(/salud menstrual/i).length).toBeGreaterThan(0)
    expect(screen.getByRole('heading', { name: /selección de fotos de intervención/i, level: 2 })).toBeTruthy()
    expect(screen.getAllByAltText(/acci/i).length).toBeGreaterThan(0)
  })
})
